<ng-container>
  <button class="task-button"
    [class.passage-task-button]="taskSelect()!.showPassageTitle"
    [class.task-button-disabled]="taskSelect()!.disabled"
    [style.background-image]="'url(' + taskSelect()!.buttonImage + ')'"
    [disabled]="taskSelect()!.disabled || initializing()"
    (click)="onTaskClick()"
    (touchstart)="onTouchStart()"
    (touchend)="onTouchEnd($event)"
    (mouseover)="onMouseOver()"
    (mouseleave)="onMouseLeave()">

    @if (alternating()) {
      <p class="font-18 task-btn-task-type" [hidden]="taskSelect()!.showPassageTitle">{{taskSelect()!.type}}</p>
      <p class="font-18 task-btn-task-name" [hidden]="taskSelect()!.showPassageTitle">{{taskSelect()!.name}}</p>
      <p [hidden]="!taskSelect()!.showPassageTitle"
        class="task-btn-passage-title font-passage-title"
        [class.passage-title-long]="isLongPassageTitle"
        [class.passage-title-tall]="passageTitleLineCount >= 4"
      >{{ formattedPassageTitle }}</p>
      <img class="task-btn-icon" [src]="taskSelect()!.icon">
      @if (compareScores()) {
        @if (compareScores() && taskSelect()!.shouldDisplayPreviousScore()) {
          <p class="font-18 task-btn-task-points">{{ taskSelect()!.displayPreviousScore() }}</p>
        }
        @if (taskSelect()!.shouldDisplayScore()) {
          <p class="font-18 task-btn-task-score">{{ taskSelect()!.displayScore() }}</p>
        }
      } @else {
        <div class="score-container">
          <div class="scorebox-wrapper" [class]="wrapperGrids" [class.passage-scorebox-wrapper]="taskSelect()!.showPassageTitle">
            @for (scoreBox of scoreBoxes; track scoreBox.id) {
              @if (scoreBox.icon) {
                <p class="font-18 task-btn-passage-scorebox" [style.background-image]="'url(' + scoreBox.background + ')'">
                  <img src="{{ scoreBox.icon }}" />
                </p>
              } @else {
                <p class="font-18 task-btn-scorebox" [style.background-image]="'url(' + scoreBox.background + ')'">
                  {{ scoreBox.started ? scoreBox.score + '%' : '' }}
                </p>
              }
            }
          </div>
        </div>
      }
    } @else {
      <p class="font-18 pre-task-btn-task-type" [hidden]="taskSelect()!.showPassageTitle">{{taskSelect()!.type}}</p>
      <p class="font-18 pre-task-btn-task-name" [hidden]="taskSelect()!.showPassageTitle">{{taskSelect()!.name}}</p>
      <p [hidden]="!taskSelect()!.showPassageTitle"
        class="task-btn-passage-title font-passage-title"
        [class.passage-title-long]="isLongPassageTitle"
        [class.passage-title-tall]="passageTitleLineCount >= 4"
      >{{ formattedPassageTitle }}</p>
      <img class="pre-task-btn-icon" [src]="taskSelect()!.icon">
      @if (isPreDiagnosticStudent() && taskSelect()!.shouldDisplayScore()) {
        <p class="font-18 pre-task-btn-task-score"
          [class]="{'left-task-score': taskSelect()!.pointsLeft, 'secondary-theme' : (taskSelect()!.theme === themes.secondary) }"
        >{{ taskSelect()!.displayScore() }}</p>
      }
      @if (!isPreDiagnosticStudent() && compareScores() && taskSelect()!.shouldDisplayPreviousScore()) {
        <p class="font-18 diagnostic-task-btn-task-prev-score"
          [class]="{'left-task-score': taskSelect()!.pointsLeft, 'secondary-theme' : (taskSelect()!.theme === themes.secondary) }"
        >{{ taskSelect()!.displayPreviousScore() }}</p>
      }
      @if (!isPreDiagnosticStudent() && taskSelect()!.shouldDisplayScore()) {
        <p class="font-18 diagnostic-task-btn-task-score"
          [class]="{'left-task-score': taskSelect()!.pointsLeft, 'secondary-theme' : (taskSelect()!.theme === themes.secondary) }"
        >{{ taskSelect()!.displayScore() }}</p>
      }
    }
  </button>
</ng-container>
